import { render, staticRenderFns } from "./BlockIps.vue?vue&type=template&id=4a2c91b8&scoped=true"
import script from "./BlockIps.vue?vue&type=script&lang=js"
export * from "./BlockIps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2c91b8",
  null
  
)

export default component.exports